module.exports = __webpack_public_path__ + "fonts/montserrat-light-webfont.8cde2a0e8a4a698a32a3b1c295b9fa8b.svg?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.svg
// module id = 735
// module chunks = 9